export default __webpack_public_path__ + "static/media/Medak.422ea634.png";